// extracted by mini-css-extract-plugin
export var buttonsWrapper = "social-image-module--buttonsWrapper--23c64";
export var controlButton = "social-image-module--controlButton--c5421";
export var infoInner = "social-image-module--infoInner--c99f2";
export var infoWrapper = "social-image-module--infoWrapper--a2211";
export var wrapper = "social-image-module--wrapper--745f1";